import { LOCALES } from './locales'

export const messages = {
  [LOCALES.ENGLISH]: {
    devices: 'Devices',
    collectors: 'Collectors',
    customers: 'Customers',
    places: 'Places',
    pools: 'Pools',
    tickets: 'Tickets',
    meters: 'Meters',
    noMeters: 'No meters available in the system.',
    searchMeter: 'Search meter...',
    crontab: 'Crontab',
    system: 'System',
    email: 'Email',
    notify: 'Notify',
    template: 'Templates',
    templateEditTitle: 'Edit: {action} / {direction}',
    templateHtml: 'HTML',
    templatePreview: 'Preview',
    templatePreviewPlaceholder: 'Preview will appear here.',
    cancel: 'Cancel',
    action: 'Action',
    direction: 'Direction',
    billing: 'Billing',
    tariff: 'Tariff',
    tariffDescription: 'Defaylt price for electricity',
    tariffPriority: 'Tariff Priority',
    tariffPriorityDescription: 'Tariff selection priority',
    electricityLosses: 'Electricity losses',
    electricityLossesDesc: 'Percent for electricity losses',
    deviceReading: 'Device readings',
    settings: 'Settings',
    settingsPrint: 'Print Settings',
    modbusDevices: 'Modbus Devices',
    usersGroups: 'Users and Groups',
    logs: 'Logs',
    users: 'Users',
    groups: 'Groups',
    openTickets: 'Open Tickets',
    newDevices: 'New Devices',
    offlineDevices: 'Offline Devices',
    cronToday: 'CronTask Today',
    avgHealth: 'Average Health',
    errorsScan: 'Errors Scan',
    placesHealth: 'Places Health',
    open: 'Open',
    reportSummary: 'Summary Report',
    create: 'Create',
    save: 'Save',
    close: 'Close',
    delete: 'Delete',
    newRecord: 'New Record',
    year: 'Year',
    month: 'Month',
    quarter: 'Quarter',
    prepareReport: 'Prepare Report',
    general: 'General',
    additional: 'Additional',
    assignDevice: 'Assign device',
    deletePlace: 'Delete Place',
    deletePlaceMsg: 'Delete this place and all nested places and groups',
    groupPlace: 'Group Place',
    customer: 'Customer',
    deleteCustomer: 'Delete Customer',
    deleteCustomerMsg: 'Should I delete this customer and all sub customers?',
    balance: 'Balance',
    balanceManagement: 'Balance Management',
    earnings: 'Earnings',
    actions: 'Actions',
    edit: 'Edit',
    billingSettings: 'Billing Settings',
    metersSettings: 'Meters Settings',
    editCustomer: 'Edit Customer',
    newCustomer: 'New Customer',
    typeCustomer: 'Customer Type',
    INNCustomer: 'Customer IIN',
    OGRNCustomer: 'Customer OGRN',
    KPPCustomer: 'Customer KPP',
    companyName: 'Company Name',
    ownerSurname: 'Owner Surname',
    ownerName: 'Owner Name',
    ownerPatronymic: 'Owner Patronymic',
    description: 'Description',
    deviceCount: 'Device count',
    blocked: 'Blocked',
    created: 'Created',
    default: 'Default',
    subcustomers: 'SubCustomers',
    label: 'Name',
    add: 'Add',
    importData: 'Import data',
    importDataDescription: 'Upload CSV with columns: UUID;SN;Vendor;Model;Date;Electricity;Hours (separator — semicolon).',
    downloadExampleCsv: 'Download example.csv',
    selectFile: 'Select file',
    uploadError: 'Upload error',
    importError: 'Import error',
    upload: 'Upload',
    loading: 'Loading...',
    result: 'Result',
    uuidCount: 'UUID count',
    electricity: 'Electricity',
    hours: 'Hours',
    models: 'Models',
    model: 'Model',
    count: 'Count',
    newDeviceNotFound: 'Devices not found in system (new_device)',
    next: 'Next',
    importInProgress: 'Import...',
    importDone: 'Import completed.',
    uploadAnotherFile: 'Upload another file',
    deleteConfirm: 'Delete row?',
    reportTime: 'Time',
    docNumber: 'Doc Number',
    errors: 'Errors',
    status: 'Status',
    download: 'Download',
    deleteSummaryReportInfo: 'Don\'t delete report if you already sended it to customer',
    // Profile page
    userProfile: 'User Profile',
    profile: 'Profile',
    account: 'Account',
    notifications: 'Notifications',
    activeSession: 'Active session',
    uploadProfileImage: 'Upload a New Profile Image',
    profileImageHint: 'Ideal dimensions are 500px x 500px. Maximum file size is 5mb.',
    displayName: 'Display Name',
    displayNamePlaceholder: 'John Smith',
    emailAddress: 'Email address',
    emailPlaceholder: 'name@example.com',
    telegramUserId: 'Telegram user id',
    telegramPlaceholder: '12345678',
    language: 'Language',
    languageRussian: 'Russian',
    languageEnglish: 'English',
    passwordSettings: 'Password Settings',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    mfaSettings: 'MFA Settings',
    twoFactorStatus: 'Two-factor authentication is',
    enabled: 'Enabled',
    disabled: 'Disabled',
    disable2FA: 'Disabled 2FA',
    enable2FA: 'Enabled 2FA',
    enterTOTPVerify: 'Enter TOTP for verify',
    apply: 'Apply',
    downloadGoogleAuth: 'Download Google Authenticator from',
    googlePlay: 'Google Play',
    appStore: 'App Store',
    or: 'or',
    emailNotification: 'Email Notification',
    telegramNotification: 'Telegram Notification',
    created: 'Created',
    expire: 'Expire',
    ip: 'IP',
    userAgent: 'User Agent',
    exitFromAllSessions: 'Exit from all session',
    errorGetSessions: 'Error get sessions',
    errorGetUserInfo: 'Error get user info',
    errorChangePassword: 'Error change password',
    errorChangeInfo: 'Error change info',
    errorDeleteSessions: 'Error delete sessions',
    errorSetTelegram: 'Error set telegram',
    errorUploadFile: 'Error upload file',
    errorMFA: 'Error MFA',
    passwordChanged: 'Password is changed',
    success: 'Success',
    userInfoChanged: 'User info is changed',
    telegramConnected: 'Telegram connected',
    fileUploaded: 'File uploaded',
    update: 'Update',
    // Device logs page
    time: 'Time',
    uuid: 'UUID',
    user: 'User',
    filterAny: 'Any',
    filterTrue: 'True',
    filterFalse: 'False',
    placeholderUuid: '00:00:00:00:00:00',
    logsActionNew: 'New',
    logsActionArchive: 'Archive',
    logsActionPause: 'Pause',
    logsActionPoolChanged: 'Pool Changed',
    logsActionCollectorChanged: 'Collector Changed',
    logsActionSetCustomer: 'Set Customer',
    logsActionPlaceChanged: 'Place Changed',
    logsActionVendorChanged: 'Vendor Changed',
    logsActionReboot: 'Reboot',
    logsActionAddTag: 'Add Tag',
    logsActionDeleteTag: 'Delete Tag',
    logsActionSerialNumberChanged: 'Serial Number Changed',
    scan_errors: 'Scan Errors',
    unknown_devices: 'Unknown Devices',
    prediction: 'Prediction',
    audit: 'Audit',
    find_miners: 'Find devices',
    device_duplicates: 'Device duplicates',
    import_data: 'Import data',
    run: 'Run',
    collector_id: 'Collector ID',
    mac: 'MAC',
    last_seen: 'Last seen',
    no_duplicates_found: 'No duplicates found',
    reset_filter: 'Reset filter',
    options: 'Options',
    vendor: 'Vendor',
    find_miners_known: 'Known',
    find_miners_reload: 'Reload',
    find_miners_select_placeholder: 'Open this select menu',
    find_miners_move_to_location: 'Move to location',
    find_miners_unmark_known: 'Unmark as known',
    find_miners_mark_known: 'Mark as known',
    find_miners_choose_action: 'Choose action',
    find_miners_apply: 'Apply',
    find_miners_location_changed: 'Location is changed',
    find_miners_location_error: 'Location Error',
    find_miners_unmark_done: 'Unmarked as unknown',
    find_miners_mark_done: 'Marked as known',
    find_miners_error_get_logs: 'Error loading logs',
    find_miners_error_set_location: 'Error setting location',
    // Device consumption tab
    deviceConsumption: 'Consumption',
    billingControl: 'Control',
    billingDetail: 'Detail:',
    billingByHours: 'By hours',
    billingByConsumption: 'By consumption',
    billingDateStart: 'Start date',
    billingDateEnd: 'End date',
    billingLoad: 'Load',
    billingChart: 'Chart',
    billingSummary: 'Summary',
    billingTotalConsumption: 'Total consumption for period:',
    billingTotalHours: 'Total hours:',
    billingAvgPerDay: 'Average consumption per day:',
    billingExportCsv: 'Export to CSV',
    billingSelectPeriodHint: 'Select period and click «Load»',
    billingChartHours: 'Hours',
    billingChartConsumptionKwh: 'Consumption, kWh',
    billingChartKwh: 'kWh',
    billingExportCsvToast: 'CSV Export',
    billingErrorExport: 'Export error',
    main: 'Main',
    ok: 'Ok',
    addGroup: 'Add Group',
    view: 'View',
    placeColumn: 'Place',
    led: 'LED',
    assign: 'Assign',
    groupNamePlaceholder: 'Group Name',
    placeLabelPlaceholder: 'BL1',
    placeDescPlaceholder: 'Group Description',
    placeNameExample: 'Example: Build 1',
    placeLabelExample: 'Example: BL1',
    placeDescExample: 'Example: Building number 1, floor 6, room 305',
    placeTariffPlaceholder: 'Group billing tariff',
    placeTariffExample: 'Example: 5.1',
    itsPlace: "It's Place",
    placeX: 'X',
    placeY: 'Y',
    fiasGuid: 'FIAS GUID',
    cadastral: 'Cadastral',
    address: 'Address',
    name: 'Name',
    devicesCount: 'Devices: {count}({nested})',
    online: 'Online',
    offline: 'Offline',
    fan: 'Fan',
  },
  [LOCALES.RUSSIAN]: {
    devices: 'Устройства',
    collectors: 'Коллекторы',
    customers: 'Заказчики',
    places: 'Локации',
    pools: 'Пулы',
    tickets: 'Задачи',
    meters: 'Счетчики',
    noMeters: 'В системе нет доступных счетчиков.',
    searchMeter: 'Поиск счетчика...',
    crontab: 'Планировщик',
    system: 'Системные',
    notify: 'Уведомления',
    template: 'Шаблоны',
    templateEditTitle: 'Редактирование: {action} / {direction}',
    templateHtml: 'HTML',
    templatePreview: 'Предпросмотр',
    templatePreviewPlaceholder: 'Здесь будет предпросмотр.',
    cancel: 'Отмена',
    action: 'Действие',
    direction: 'Направление',
    billing: 'Биллинг',
    tariff: 'Тариф',
    tariffDescription: 'Цена электроэнергии по умолчанию',
    tariffPriority: 'Приоритет тарифа',
    tariffPriorityDescription: 'Приоритет выбора тарифа',
    electricityLosses: 'Электропотери',
    electricityLossesDesc: 'Процент потерь электроэнергии',
    deviceReading: 'Данные с устройства',
    email: 'Почта',
    settings: 'Настройки',
    modbusDevices: 'Modbus устройства',
    logs: 'Журналы',
    settingsPrint: 'Настройки печати',
    usersGroups: 'Пользователи и Группы',
    users: 'Пользователи',
    groups: 'Группы',
    openTickets: 'Открытые тикеты',
    newDevices: 'Новые устройства',
    offlineDevices: 'Выключенные устройства',
    cronToday: 'Планировщик сегодня',
    avgHealth: 'Среднее здоровье',
    errorsScan: 'Ошибки сканирования',
    placesHealth: 'Здоровье локаций',
    open: 'Открыть',
    reportSummary: 'Итоговый отчет',
    create: 'Создать',
    close: 'Закрыть',
    save: 'Сохранить',
    delete: 'Удалить',
    newRecord: 'Новая запись',
    year: 'Год',
    month: 'Месяц',
    quarter: 'Квартал',
    prepareReport: 'Подготовить отчет',
    general: 'Основное',
    additional: 'Дополнительное',
    assignDevice: 'Присвоить устройство',
    deletePlace: 'Удалить локацию',
    deletePlaceMsg: 'Удалить локацию и все вложенные включая места?',
    groupPlace: 'Группа локаций',
    customer: 'Заказчик',
    deleteCustomer: 'Удалить заказчика',
    deleteConfirm: 'Удалить запись?',
    deleteCustomerMsg: 'Удалить заказчика и всех подчиненных заказчиков?',
    balance: 'Баланс',
    balanceManagement: 'Управление балансом',
    earnings: 'Добыча',
    actions: 'Действия',
    edit: 'Изменить',
    billingSettings: 'Настройки биллинга',
    metersSettings: 'Настройки счетчиков',
    editCustomer: 'Изменить заказчика',
    newCustomer: 'Новый заказчик',
    typeCustomer: 'Тип заказчика',
    INNCustomer: 'ИНН',
    OGRNCustomer: 'ОГРН',
    KPPCustomer: 'КПП',
    companyName: 'Наименование огранизации',
    ownerSurname: 'Фамилия',
    ownerName: 'Имя',
    ownerPatronymic: 'Отчество',
    description: 'Описание',
    deviceCount: 'Колличество устройств',
    blocked: 'Заблокирован',
    created: 'Создан',
    default: 'По умолчанию',
    subcustomers: 'Подчиненные заказчики',
    label: 'Название',
    add: 'Добавить',
    importData: 'Импорт данных',
    importDataDescription: 'Загрузите CSV с колонками: UUID;SN;Vendor;Model;Date;Electricity;Hours (разделитель — точка с запятой).',
    downloadExampleCsv: 'Скачать example.csv',
    selectFile: 'Выберите файл',
    uploadError: 'Ошибка загрузки',
    importError: 'Ошибка импорта',
    upload: 'Загрузить',
    loading: 'Загрузка...',
    result: 'Результат',
    uuidCount: 'Количество UUID',
    electricity: 'Электричество',
    hours: 'Часы',
    models: 'Модели',
    model: 'Модель',
    count: 'Количество',
    newDeviceNotFound: 'Устройства не найдены в системе (Новые устройства)',
    next: 'Далее',
    importInProgress: 'Импорт...',
    importDone: 'Импорт выполнен.',
    uploadAnotherFile: 'Загрузить другой файл',
    reportTime: 'Время',
    docNumber: 'Номер документа',
    errors: 'Ошибки',
    status: 'Статус',
    download: 'Скачать',
    deleteSummaryReportInfo: 'Не удаляйте отчет, если вы отправили его заказчику.',
    // Profile page
    userProfile: 'Профиль пользователя',
    profile: 'Профиль',
    account: 'Аккаунт',
    notifications: 'Уведомления',
    activeSession: 'Активные сессии',
    uploadProfileImage: 'Загрузить новое фото профиля',
    profileImageHint: 'Рекомендуемый размер 500x500 px. Максимальный размер файла 5 МБ.',
    displayName: 'Отображаемое имя',
    displayNamePlaceholder: 'Иван Иванов',
    emailAddress: 'Email',
    emailPlaceholder: 'name@example.com',
    telegramUserId: 'Telegram user id',
    telegramPlaceholder: '12345678',
    language: 'Язык',
    languageRussian: 'Русский',
    languageEnglish: 'Английский',
    passwordSettings: 'Настройки пароля',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    mfaSettings: 'Настройки MFA',
    twoFactorStatus: 'Двухфакторная аутентификация',
    enabled: 'Включена',
    disabled: 'Выключена',
    disable2FA: 'Выключить 2FA',
    enable2FA: 'Включить 2FA',
    enterTOTPVerify: 'Введите TOTP для проверки',
    apply: 'Применить',
    downloadGoogleAuth: 'Скачайте Google Authenticator в',
    googlePlay: 'Google Play',
    appStore: 'App Store',
    or: 'или',
    emailNotification: 'Уведомления по Email',
    telegramNotification: 'Уведомления в Telegram',
    created: 'Создана',
    expire: 'Истекает',
    ip: 'IP',
    userAgent: 'User Agent',
    exitFromAllSessions: 'Выйти из всех сессий',
    errorGetSessions: 'Ошибка получения сессий',
    errorGetUserInfo: 'Ошибка получения данных пользователя',
    errorChangePassword: 'Ошибка смены пароля',
    errorChangeInfo: 'Ошибка изменения данных',
    errorDeleteSessions: 'Ошибка удаления сессий',
    errorSetTelegram: 'Ошибка привязки Telegram',
    errorUploadFile: 'Ошибка загрузки файла',
    errorMFA: 'Ошибка MFA',
    passwordChanged: 'Пароль изменён',
    success: 'Успешно',
    userInfoChanged: 'Данные изменены',
    telegramConnected: 'Telegram подключён',
    fileUploaded: 'Файл загружен',
    update: 'Обновить',
    // Device logs page
    time: 'Время',
    uuid: 'UUID',
    user: 'Пользователь',
    filterAny: 'Любой',
    filterTrue: 'Да',
    filterFalse: 'Нет',
    placeholderUuid: '00:00:00:00:00:00',
    logsActionNew: 'Новый',
    logsActionArchive: 'Архив',
    logsActionPause: 'Пауза',
    logsActionPoolChanged: 'Пулы изменены',
    logsActionCollectorChanged: 'Коллектор изменён',
    logsActionSetCustomer: 'Назначить заказчика',
    logsActionPlaceChanged: 'Локация изменена',
    logsActionVendorChanged: 'Вендор изменён',
    logsActionReboot: 'Перезагрузка',
    logsActionAddTag: 'Добавить тег',
    logsActionDeleteTag: 'Удалить тег',
    logsActionSerialNumberChanged: 'Серийный номер изменён',
    scan_errors: 'Ошибки сканирования',
    unknown_devices: 'Неизвестные уст-ва',
    prediction: 'Предсказания',
    audit: 'Аудит',
    find_miners: 'Поиск устройств',
    device_duplicates: 'Дубликаты устройств',
    import_data: 'Импорт данных',
    run: 'Запуск',
    collector_id: 'Коллектор ID',
    mac: 'MAC',
    last_seen: 'Последний визит',
    no_duplicates_found: 'Дубликатов не найдено',
    reset_filter: 'Сброс фильтра',
    options: 'Опции',
    vendor: 'Вендор',
    find_miners_known: 'Известные',
    find_miners_reload: 'Обновить',
    find_miners_select_placeholder: 'Выберите действие',
    find_miners_move_to_location: 'Переместить в локацию',
    find_miners_unmark_known: 'Отменить как известное',
    find_miners_mark_known: 'Пометить как известное',
    find_miners_choose_action: 'Выберите действие',
    find_miners_apply: 'Применить',
    find_miners_location_changed: 'Локация изменена',
    find_miners_location_error: 'Ошибка локации',
    find_miners_unmark_done: 'Снята пометка «известное»',
    find_miners_mark_done: 'Помечено как известное',
    find_miners_error_get_logs: 'Ошибка загрузки журнала',
    find_miners_error_set_location: 'Ошибка установки локации',
    // Device consumption tab
    deviceConsumption: 'Потребление',
    billingControl: 'Управление',
    billingDetail: 'Детализация:',
    billingByHours: 'По часам',
    billingByConsumption: 'По потреблению',
    billingDateStart: 'Дата начала',
    billingDateEnd: 'Дата окончания',
    billingLoad: 'Загрузить',
    billingChart: 'График',
    billingSummary: 'Сводка',
    billingTotalConsumption: 'Общее потребление за период:',
    billingTotalHours: 'Общее количество часов:',
    billingAvgPerDay: 'Среднее потребление в сутки:',
    billingExportCsv: 'Экспорт в CSV',
    billingSelectPeriodHint: 'Выберите период и нажмите «Загрузить»',
    billingChartHours: 'Часы',
    billingChartConsumptionKwh: 'Потребление, кВт·ч',
    billingChartKwh: 'кВт·ч',
    billingExportCsvToast: 'Экспорт CSV',
    billingErrorExport: 'Ошибка экспорта',
    main: 'Основная',
    ok: 'Ок',
    addGroup: 'Добавить группу',
    view: 'Просмотр',
    placeColumn: 'Место',
    led: 'LED',
    assign: 'Назначить',
    groupNamePlaceholder: 'Название группы',
    placeLabelPlaceholder: 'BL1',
    placeDescPlaceholder: 'Описание группы',
    placeNameExample: 'Например: Корпус 1',
    placeLabelExample: 'Например: BL1',
    placeDescExample: 'Например: Корпус 1, этаж 6, комната 305',
    placeTariffPlaceholder: 'Тариф биллинга',
    placeTariffExample: 'Например: 5.1',
    itsPlace: 'Это место',
    placeX: 'X',
    placeY: 'Y',
    fiasGuid: 'ФИАС GUID',
    cadastral: 'Кадастровый',
    address: 'Адрес',
    name: 'Название',
    devicesCount: 'Устройств: {count}({nested})',
    online: 'В сети',
    offline: 'Не в сети',
    fan: 'Вентилятор',
  },
}
